import { Component } from '@angular/core';

@Component({
  selector: 'app-transaction-skeleton',
  templateUrl: './transaction-skeleton.component.html',
  styleUrls: ['./transaction-skeleton.component.scss']
})
export class TransactionSkeletonComponent {

}
